module.exports = __webpack_public_path__ + "static/img/hold-tight.0962445.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/start/hold-tight.png
// module id = 503
// module chunks = 0